import React from 'react'
import Preload from 'components/ui/Preload'
import Layout from 'components/ui/Layout'

type Props = $ReadOnly<{
  prefix: ?string,
  id: string,
}>

function LayoutedPreload({prefix, id}: Props) {
  return (
    <Layout id={prefix ? `${prefix}-${id}` : id}>
      <Preload />
    </Layout>
  )
}

LayoutedPreload.defaultProps = {
  prefix: null,
}

export default LayoutedPreload
